/** @format */

import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';
const errorMessages = {
  // Firebase의 auth 에러 메세지 정의
  accountExistsWithDifferentCredential: {
    title: '계정 안내!',
    subTitle: '이미 있는 계정입니다.',
  },
  invalidCredential: {
    title: '인증 오류!',
    subTitle: '로그인 인증에 오류가 발생했습니다.',
  },
  operationNotAllowed: {
    title: '로그인 실패!',
    subTitle:
      '로그인 과정에서 오류가 발생했습니다. 관리자에게 문의하시길 바랍니다.',
  },
  userDisabled: {
    title: '정지 계정!',
    subTitle: '정지된 계정입니다. 관리자에게 연락하시길 바랍니다.',
  },
  userNotFound: { title: '계정 없음!', subTitle: '해당 계정 정보가 없습니다.' },
  userEmailNotFound: {
    title: '가입된 이메일 주소가 아닙니다.',
    subTitle: '다시 확인해 주시기 바랍니다.',
  },
  wrongPassword: {
    title: '비밀번호 오류!',
    subTitle: '입력하신 비밀번호가 잘못되었습니다.다시 확인하시기 바랍니다.',
  },
  invalidEmail: {
    title: '이메일 오류!',
    subTitle: '입력하신 이메일 정보가 없습니다. 다시 확인하시기 바랍니다.',
  },
  emailAlreadyInUse: {
    title: '사용할 수 없는 이메일!',
    subTitle: '이미 사용중인 이메일입니다. 다시 확인하시기 바랍니다.',
  },
  weakPassword: {
    title: '비밀번호 경고!',
    subTitle: '입력하신 비밀번호가 보안에 취약합니다.',
  },
  requiresRecentLogin: {
    title: '인증 만료!',
    subTitle: '인증이 만료되었습니다. 다시 로그인 하시기 바랍니다.',
  },
  userMismatch: {
    title: '사용자 불일치!',
    subTitle: '다른 사용자의 인증정보입니다!',
  },
  providerAlreadyLinked: {
    title: 'Already Linked!',
    subTitle: 'Sorry, but your account is already linked to this credential.',
  },
  credentialAlreadyInUse: {
    title: '불가능 인증정보!',
    subTitle: 'Sorry, but this credential is already used by another user.',
  },
  toManyrequests: {
    title: '확인 횟수 초과!',
    subTitle:
      '잘못된 비밀번호로 비밀번호 확인 횟수가 초과 되었습니다. 잠시 후 다시 시도하시기 바랍니다.',
  },
};
@Injectable({
  providedIn: 'root',
})
export class AlertService {
  /**
   * icon
   * success,error,warning,info,question
   */

  constructor() {}

  showErrorMessage(code) {
    switch (code) {
      // Firebase Error Messages
      case 'auth/account-exists-with-different-credential':
        this.errormsg(
          errorMessages.accountExistsWithDifferentCredential['title'],
          errorMessages.accountExistsWithDifferentCredential['subTitle']
        );
        break;
      case 'auth/invalid-credential':
        this.errormsg(
          errorMessages.invalidCredential['title'],
          errorMessages.invalidCredential['subTitle']
        );
        break;
      case 'auth/operation-not-allowed':
        this.errormsg(
          errorMessages.operationNotAllowed['title'],
          errorMessages.operationNotAllowed['subTitle']
        );
        break;
      case 'auth/user-disabled':
        this.errormsg(
          errorMessages.userDisabled['title'],
          errorMessages.userDisabled['subTitle']
        );
        break;
      case 'auth/user-not-found':
        this.errormsg(
          errorMessages.userEmailNotFound['title'],
          errorMessages.userEmailNotFound['subTitle']
        );
        break;
      case 'auth/wrong-password':
        this.errormsg(
          errorMessages.wrongPassword['title'],
          errorMessages.wrongPassword['subTitle']
        );
        break;
      case 'auth/invalid-email':
        this.errormsg(
          errorMessages.invalidEmail['title'],
          errorMessages.invalidEmail['subTitle']
        );
        break;
      case 'auth/email-already-in-use':
        this.errormsg(
          errorMessages.emailAlreadyInUse['title'],
          errorMessages.emailAlreadyInUse['subTitle']
        );
        break;
      case 'auth/weak-password':
        this.errormsg(
          errorMessages.weakPassword['title'],
          errorMessages.weakPassword['subTitle']
        );
        break;
      case 'auth/requires-recent-login':
        this.errormsg(
          errorMessages.requiresRecentLogin['title'],
          errorMessages.requiresRecentLogin['subTitle']
        );
        break;
      case 'auth/user-mismatch':
        this.errormsg(
          errorMessages.userMismatch['title'],
          errorMessages.userMismatch['subTitle']
        );
        break;
      case 'auth/provider-already-linked':
        this.errormsg(
          errorMessages.providerAlreadyLinked['title'],
          errorMessages.providerAlreadyLinked['subTitle']
        );
        break;
      case 'auth/credential-already-in-use':
        this.errormsg(
          errorMessages.credentialAlreadyInUse['title'],
          errorMessages.credentialAlreadyInUse['subTitle']
        );
        break;
      case 'auth/too-many-requests':
        this.errormsg(
          errorMessages.toManyrequests['title'],
          errorMessages.toManyrequests['subTitle']
        );
        break;
    }
  }

  //완료 메세지
  successmsg(title, text) {
    return Swal.fire({
      title,
      text,
      icon: 'success',
      confirmButtonText: '확인',
      customClass: {
        confirmButton: 'btn btn-success swal-alert-btn',
      },
    });
  }

  //에러 메세지
  errormsg(title, text) {
    return Swal.fire({
      title,
      text,
      icon: 'error',
      confirmButtonText: `닫기`,
      customClass: {
        confirmButton: 'btn btn-success swal-alert-btn',
      },
    });
  }

  // 대시보드 에러메시지
  dashErrormsg(title, text) {
    return Swal.fire({
      title,
      text,
      icon: 'error',
      confirmButtonText: `확인`, // 기획
      customClass: {
        confirmButton: 'btn btn-success swal-alert-btn',
      },
    });
  }

  //긍정적 컴펌 메세지
  successConfirm(title, text, confirmButtonText) {
    return new Promise((resolve, reject) => {
      Swal.fire({
        title,
        text,
        icon: 'success',
        showCancelButton: true,
        confirmButtonColor: '#34c38f',
        cancelButtonColor: '#f46a6a',
        customClass: {
          confirmButton: 'swal-alert-btn',
          cancelButton: 'swal-alert-btn',
        },
        confirmButtonText,
        cancelButtonText: '취소',
        reverseButtons: true,
      })
        .then((result) => {
          if (result.value) {
            resolve(true);
          } else {
            resolve(false);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  // 부정적 컴펌 메세지
  warningConfirm(title, text, confirmButtonText) {
    return new Promise((resolve, reject) => {
      Swal.fire({
        title,
        text,
        icon: 'error',
        showCancelButton: true,
        confirmButtonColor: '#34c38f',
        cancelButtonColor: '#f46a6a',
        customClass: {
          confirmButton: 'swal-alert-btn',
          cancelButton: 'swal-alert-btn',
        },
        confirmButtonText,
        cancelButtonText: '취소',
      })
        .then((result) => {
          if (result.value) {
            resolve(true);
          } else {
            resolve(false);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  //토스트
  swalToast(title, icon?) {
    Swal.fire({
      toast: true,
      timerProgressBar: true,
      position: 'bottom',
      icon: icon ? icon : 'success',
      title,
      showConfirmButton: false,
      timer: 2000,
    });
  }

  //이미지 얼럿
  imageHeader(title, text, imageUrl, imageHeight) {
    Swal.fire({
      title,
      text,
      imageUrl,
      imageHeight,
      confirmButtonColor: '#556ee6',
    });
  }

  //타이머 strong 태그안에 시간이 들어가도록 세팅해주세요.
  timer(title, html) {
    let timerInterval;
    Swal.fire({
      title,
      html,
      timer: 2000,
      onBeforeOpen: () => {
        Swal.showLoading();
        timerInterval = setInterval(() => {
          Swal.getContent().querySelector('strong').textContent =
            Swal.getTimerLeft() + '';
        }, 100);
      },
      onClose: () => {
        clearInterval(timerInterval);
      },
    }).then((result) => {
      if (result.dismiss === Swal.DismissReason.timer) {
      }
    });
  }

  //단별 alert 코드 참조용
  chain() {
    Swal.mixin({
      input: 'text',
      confirmButtonText: 'Next &rarr;',
      showCancelButton: true,
      confirmButtonColor: '#556ee6',
      cancelButtonColor: '#74788d',
      progressSteps: ['1', '2', '3'],
    })
      .queue([
        {
          title: 'Question 1',
          text: 'Chaining swal2 modals is easy',
        },
        'Question 2',
        'Question 3',
      ])
      .then((result) => {
        if (result) {
          Swal.fire({
            title: 'All done!',
            html:
              'Your answers: <pre><code>' +
              JSON.stringify(result) +
              '</code></pre>',
            confirmButtonText: 'Lovely!',
          });
        }
      });
  }

  //코드참고용 IP 알아오는 얼럿
  dynamicQueue() {
    const ipAPI = 'https://api.ipify.org?format=json';
    Swal.queue([
      {
        title: 'Your public IP',
        confirmButtonText: 'Show my public IP',
        text: 'Your public IP will be received ' + 'via AJAX request',
        showLoaderOnConfirm: true,
        preConfirm: () => {
          return fetch(ipAPI)
            .then((response) => response.json())
            .then((data) => Swal.insertQueueStep(data.ip))
            .catch(() => {
              Swal.insertQueueStep({
                title: 'Unable to get your public IP',
              });
            });
        },
      },
    ]);
  }
}
